import { addError, getActiveInteraction } from '../interaction-metrics';
export function setInteractionError(interactionName, error) {
  const interaction = getActiveInteraction();
  if (!interaction) {
    return;
  }
  if (interaction.ufoName !== interactionName) {
    return;
  }
  addError(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}